import { createStructuredSelector } from 'reselect';

import { formValueSelector, getFormValues, } from 'redux-form' // ES6;
import { FORM_NAME_DIRECCION, FORM_NAME_NUM_PROCESS, FORM_NAME_STEP0, FORM_NAME_STEP1, FORM_NAME_STEP2, FORM_NAME_STEP3, FORM_NAME_STEP4, FORM_NAME_STEP5, FORM_NAME_STEP6, FORM_NAME_STEP_PRINCIPAL } from './constants';

export const getFormValuesStepPricipal = (state) => getFormValues(FORM_NAME_STEP_PRINCIPAL)(state);
export const getFormValuesStep0 = (state) => getFormValues(FORM_NAME_STEP0)(state);
export const getFormValuesStep1 = (state) => getFormValues(FORM_NAME_STEP1)(state);
export const getFormValuesStep2 = (state) => getFormValues(FORM_NAME_STEP2)(state);
export const getFormValuesStep3 = (state) => getFormValues(FORM_NAME_STEP3)(state);
export const getFormValuesStep4 = (state) => getFormValues(FORM_NAME_STEP4)(state);
export const getFormValuesDireccion = (state) => getFormValues(FORM_NAME_DIRECCION)(state);
export const getFormValuesModalIdForm = (state) => getFormValues(FORM_NAME_NUM_PROCESS)(state);


export const fullFormSelector = createStructuredSelector({
    step0: getFormValuesStep0,
    step1: getFormValuesStep1,
    step2: getFormValuesStep2,
    step3: getFormValuesStep3,
    step4: getFormValuesStep4,
    stepPrincipal: getFormValuesStepPricipal,
});
export const getCatalogosCargados = (state) => state.localReducer.catalogSaved;
export const getbase64Add = (state) => state.localReducer.base64Add;
export const getBase64Start = (state) => state.localReducer.base64Start;
export const getActiveStep = (state) => state.localReducer.step;
export const getSnackBar = (state) => state.localReducer.showSnackBar;
export const getMessage = (state) => state.localReducer.message;
export const getDynamicOptions = (state) => state.localReducer.dynamicOptions;
export const getFormInitialized = (state) => state.localReducer.formInitialized;
export const getFormFiles = (state) => state.localReducer.formfiles;
export const getDynamicDisable = (state) => state.localReducer.dynamicDisable;
export const getFormValid = (state) => state.localReducer.formValid;
//________________________________________________________________
export const getActiveFormRya = (state) => state.localReducer.activeFormRyA;
export const getBase64Unique = (state) => state.localReducer.base64Unique;
export const getFormularioCustomer = (state) => state.localReducer.formularioCustomer;
export const getOpenModalDireccion = (state) => state.localReducer.openModalDireccion;
export const getNameCampoDire = (state) => state.localReducer.nameCampoDire;
export const getEstadoAfiliacionCompany = (state) => state.localReducer.estadoAfiliacionCompany;
export const getIdFormulario = (state) => state.localReducer.idFormulario;
export const getIdUser = (state) => state.localReducer.idUser;
export const getModalFlujos = (state) => state.localReducer.modalFlujos;
export const getNameAnexos = (state) => state.localReducer.nameAnexos;
export const getCambioStado = (state) => state.localReducer.cambioStado;
export const getPopSeeAnexos = (state) => state.localReducer.popSeeAnexos;
export const getModalNumProcess = (state) => state.localReducer.modalNumProcess;
export const getTableDataPersonal = (state) => state.localReducer.tableDataPersonal;
export const getOpenModalCharged = (state) => state.localReducer.openModalCharged;
export const getOpenModalFinal = (state) => state.localReducer.openModalFinal;
export const getRefeFiles = (state) => state.localReducer.refeFiles;
export const getDataPantallaInicio = (state) => state.localReducer.dataPantallaInicio;
export const getFormularioSesion = (state) => state.localReducer.formularioSesion;
export const getEmpleadorType = (state) => state.localReducer.empleadorType;
export const getStepLimite = (state) => state.localReducer.stepLimite;
export const getSolicitudes = (state) => state.localReducer.solicitudes;
export const getModalFinalForm = (state) => state.localReducer.modalFinalForm;
export const getReferenceBarcode = (state) => state.localReducer.referenceBarcode;
export const getUserInfoComercial = (state) => state.localReducer.userInfoComercial;
export const getCleanAutoComplete = (state) => state.localReducer.cleanAutoComplete;
export const getCorregimientoForm = (state) => state.localReducer.corregimientoForm;
export const getModalFormReg = (state) => state.localReducer.modalFormReg;
export const getCatalogCompleted = (state) => state.localReducer.catalogCompleted;
export const getFormDevuelto = (state) => state.localReducer.formDevuelto;
export const getTamanioFiles = (state) => state.localReducer.tamanioFiles;
export const getIdAppForm = (state) => state.localReducer.idAppForm;
export const getRevisePantalla = (state) => state.localReducer.revisePantalla;
export const getMessageConfirmation = (state) => state.localReducer.messageConfirmation;
export const getPersonalAdmin = (state) => state.localReducer.personalcontactcompany;
export const getPopUpFormPdf = (state) => state.localReducer.popUpFormPdf;
export const getMotivoDevolucion = (state) => state.localReducer.motivoDevolucion;
export const getUserPersona = (state) => state.localReducer.userPersona;
export const getSolicitudesSinfirma = (state) => state.localReducer.solicitudesSinfirma;
export const getBase64pdfSinFirma = (state) => state.localReducer.base64pdfSinFirma;
export const getErrorTryCatch = (state) => state.localReducer.errorTryCatch;
export const getOpenMondalTryCatch = (state) => state.localReducer.openMondalTryCatch;
export const getMsgParametrizados = (state) => state.localReducer.msgParametrizados;
export const getEditEnabled = (state) => state.localReducer.editEnabled;
export const getValidRnecRepLegal = (state) => state.localReducer.validRnecRepLegal;
export const getEditInfoFromBandeja = (state) => state.localReducer.editInfoFromBandeja;
export const getDatosConsultaRnec = (state) => state.localReducer.datosConsultaRnec;
export const getChangeComponentId = (state) => state.localReducer.changeComponentId;
export const getModalDeleteContact = (state) => state.localReducer.modalDeleteContact;
export const getSoportRnec = (state) => state.localReducer.soportRnec;
export const getDataRues = (state) => state.localReducer.dataRues;
